import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink, DropdownMenu, DropdownToggle, DropdownItem,UncontrolledDropdown, Row } from 'reactstrap';
import { NavLink as RRNL } from 'react-router-dom';
import LoggedContext from '../BusinessObjects/LoggedContext'
import UserProfile from '../Models/UserProfile';

export default class EsaedroNavigationBar extends Component<any, any> {
    static contextType = LoggedContext
    context!: React.ContextType<typeof LoggedContext>

    navInactiveStyle: any = { "color": "white" };
    navActiveStyle: any = { "color":"steelblue" };
    subItem: any = { "color":"black" };
    subItemActive: any = { "color":"black" };
    
    constructor (props: Readonly<any>) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);

        this.state = {
            collapsed: true
        };
    }

    toggleNavbar () {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        var linkLogin;
        var menuImpostazioni;
        var titoloPagina;
        var productName;
        var changePassword = undefined;

        if (this.context.userProfile != undefined && this.context.userProfile != null) {
      
            titoloPagina =<NavLink exact tag={RRNL} to="/changecompany" className="App-Company"> {this.context.userProfile.CompanyName}</NavLink>
            productName =<NavLink exact tag={RRNL} to="/changeproduct" className="App-Product">{this.context.userProfile.ProductCode}</NavLink>
        }
        

        if(this.context.tokenAPI > '')
        {
            linkLogin= (
                <NavLink exact tag={RRNL}  className="btn btn-outline-primary btn-small" to="/logout/">
                    <i className="fa fa-unlock"></i>&nbsp;Esci&nbsp;{this.context.username}               
                </NavLink>
                );

            changePassword = (
                <NavLink exact tag={RRNL}  className="btn btn-outline-primary btn-small" to="/changePassword/">
                    <i className="fa fa-key"></i>&nbsp;Cambia Password            
                </NavLink>
                );

            if (this.context.userProfile) {
                if (this.context.userProfile.ProtectionLevel >= 99 || (this.context.userProfile.Roles && this.context.userProfile.Roles.includes("sysadmin"))) {
                    menuImpostazioni = (
                                        <NavItem>
                                        <UncontrolledDropdown nav inNavbar>
                                            <DropdownToggle nav caret style={this.navInactiveStyle} activeStyle={this.navActiveStyle}>
                                                <i className="fa fa-cogs"></i>&nbsp;Configurazione
                                            </DropdownToggle>
                                            <DropdownMenu right>
                                                <DropdownItem>
                                                    <NavLink exact tag={RRNL} to="/resourcelist" style={this.subItem} activeStyle={this.subItemActive}>Risorse</NavLink>
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    <NavLink exact tag={RRNL} to="/jobslist" style={this.subItem} activeStyle={this.subItemActive}>Jobs sincronizzazione</NavLink>
                                                </DropdownItem>
                                                <DropdownItem divider />
                                                <DropdownItem>
                                                    <NavLink exact tag={RRNL} to="/objectslist/Companies_Agents/sys" style={this.subItem} activeStyle={this.subItemActive}>Agenti</NavLink>
                                                </DropdownItem>
                                                <DropdownItem divider />
                                            </DropdownMenu>
                                        </UncontrolledDropdown> 
                                        </NavItem>
                                    )
                    }
                }            
        }
        else
        {
            linkLogin =(<NavLink exact tag={RRNL}  className="btn btn-outline-primary btn-small" to="/login/">
                            <i className="fa fa-lock"></i>&nbsp;Login                
                        </NavLink>);

            changePassword = undefined;
            menuImpostazioni="";
        }

        return (
            <header>
                <Navbar dark className="navbar-expand-sm navbar-toggleable-sm bg-dark ng-white border-bottom box-shadow mb-3" light>
                    <Container>
                    
                        <NavbarBrand tag={RRNL} to="/"><img src="/images/admin_portal_white.jpg" /></NavbarBrand>
                        {titoloPagina?titoloPagina:undefined}
                        {productName?productName:undefined}
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                
                                <NavItem>
                                    <NavLink exact tag={RRNL} to="/home" style={this.navInactiveStyle} activeStyle={this.navActiveStyle}>
                                        <i className="fa fa-home"></i>&nbsp;Home
                                    </NavLink>
                                </NavItem>
                                    {menuImpostazioni}
                                <NavItem>
                                    <NavLink exact tag={RRNL} to="/about" style={this.navInactiveStyle} activeStyle={this.navActiveStyle}>
                                        <i className="fa fa-info-circle"></i>&nbsp;About
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    {linkLogin}
                                </NavItem>
                                <NavItem>
                                    {changePassword}
                                </NavItem>
                            </ul>                        
                        </Collapse>
            
                    </Container>
                    
                </Navbar>
            </header>
        )
  }
}
